import { faSearch } from '@fortawesome/pro-light-svg-icons';

import './SearchBar.css';

import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../shared/components/button/Button';
import { useHttpClient } from '../shared/hooks/http-hook';

function SearchBar(props) {
  const { sendRequest } = useHttpClient();
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState();
  const [times, setTimes] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState();

  const handleQuit = () => {
    setShowSuggestions(false);
    setSearchTerm('');
    setTimes(false);
    props.setMedia([]);
    props.setNoResults(false);
  };

  const handleSearchChange = (e) => {
    props.setNoResults(false);
    setSearchTerm(e.target.value);
    if (e.target.value.length > 0) {
      setTimes(true);
    }
    if (e.target.value.length < 3) {
      setShowSuggestions(false);
    }
    if (e.target.value.length > 2) {
      fetchData(e.target.value);
      setShowSuggestions(true);
    }
  };

  const handleTermSelect = (e) => {
    performSearch(e.target.innerText);
  };

  const performSearch = async (term) => {
    fetchData(term, 'full');
    setSearchTerm(term);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter' && e.target.value.length > 2) {
      performSearch(e.target.value);
    }
  };

  const handleSearchClick = () => {
    if (searchTerm?.length < 3) return;
    fetchData(searchTerm, 'full');
  };

  const fetchData = async (term, searchType) => {
    const searchTermParam = searchType !== 'full' ? `pre-${term}` : term;
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/media/search/${searchTermParam}`
      );
      if (responseData) {
        setSuggestions(responseData.suggestions);
        if (searchType === 'full') {
          if (responseData.media.length > 0) {
            props.setMedia(responseData.media);
            props.setNoResults(false);
          } else {
            props.setNoResults(true);
            props.setMedia([]);
          }
        }
      }
    } catch (err) {}
  };

  return (
    <search className="search">
      <div className="search-bar-container">
        <label className="search_section_title" htmlFor="search-input">
          {t('E006')}
        </label>
        <div className="search-bar-wrapper">
          <div className="search_field">
            <FontAwesomeIcon icon={faSearch} className="icon search" />
            <input
              type="text"
              className="search_input"
              onChange={handleSearchChange}
              onKeyDown={handleSearchKeyPress}
              value={searchTerm}
              id="search-input"
            />
            {times && (
              <button
                type="button"
                aria-labelledby="search-label"
                className="transparent-button icon times"
                onClick={handleQuit}
              >
                <span id="search-label" hidden>
                  {t('explore.search.clear.button.label')}
                </span>
                <FontAwesomeIcon icon={faCircleXmark} />
              </button>
            )}
          </div>
          <Button className="search-button" onClick={handleSearchClick}>
            {t('explore.search.button.label')}
          </Button>
        </div>
      </div>

      <div
        className={`search_suggestions ${
          showSuggestions && suggestions?.length > 0 ? 'show' : ''
        } fs-mask`}
      >
        {showSuggestions &&
          suggestions?.length > 0 &&
          suggestions.map((suggestion) => (
            <Button
              key={suggestion}
              color="dark"
              className={`${showSuggestions && suggestions?.length > 0 ? 'show' : ''} fs-mask`}
              onClick={handleTermSelect}
            >
              {suggestion}
            </Button>
          ))}
      </div>
    </search>
  );
}

export default SearchBar;
